import { createSlice } from "@reduxjs/toolkit"

import {
  activateTabHandler,
  closeMenuHandler,
  collapseAllHandler,
  collapseRoomHandler,
  enterSidebarEditingHandler,
  exitSidebarEditingHandler,
  expandAllHandler,
  expandProductPositionHandler,
  openMenuHandler,
  selectElementHandler,
  setElementPendingHandler,
  setSidebarActiveTabHandler,
  unselectAllHandler,
  unsetElementPendingHandler
} from "./projectStoreActionHandlers"
import { ProjectReducerState } from "./types"

const initialState: ProjectReducerState = {}

const projectSlice = createSlice({
  name: "project-store",
  initialState,
  reducers: {
    activateFloor: activateTabHandler,
    selectElement: selectElementHandler,
    openElementDetails: openMenuHandler,
    closeElementDetails: closeMenuHandler,
    unselectAll: unselectAllHandler,
    setElementPending: setElementPendingHandler,
    unsetElementPending: unsetElementPendingHandler,
    collapseRoom: collapseRoomHandler,
    expandProductPosition: expandProductPositionHandler,
    collapseAll: collapseAllHandler,
    expandAll: expandAllHandler,
    enterSidebarEditing: enterSidebarEditingHandler,
    exitSidebarEditing: exitSidebarEditingHandler,
    setSidebarActiveTab: setSidebarActiveTabHandler
  }
})

export const {
  selectElement,
  openElementDetails,
  closeElementDetails,
  unselectAll,
  collapseRoom,
  expandProductPosition,
  collapseAll,
  expandAll,
  setElementPending,
  unsetElementPending,
  enterSidebarEditing,
  exitSidebarEditing,
  setSidebarActiveTab
} = projectSlice.actions

const { actions } = projectSlice

export { actions }

export default projectSlice.reducer
